import { OptionType, SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types';
import { RateSegment } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';

export interface RateSegmentInfoCard {
  title: string;
  showFavoriteCard: boolean;
  label: string;
  userRoles: SupportedUserRoles[];
}

export type RateSegmentInfo = {
  [K in Extract<RateSegment, 'GROUP' | 'CUSTOM'> | 'ALL']: RateSegmentInfoCard;
};

export const RATE_SEGMENT_INFO: RateSegmentInfo = Object.freeze({
  // It is used only for filters on Favorite Proposals page
  ALL: {
    label: 'All',
    userRoles: [],
    title: '',
    showFavoriteCard: false,
  },
  GROUP: {
    label: 'Small Group',
    userRoles: [],
    title: 'Select a product type from the Small Group catalog.',
    showFavoriteCard: true,
  },
  CUSTOM: {
    label: 'Custom',
    userRoles: ['IM_CELTICS'],
    title: 'Select a product type from the RFQ catalog.',
    showFavoriteCard: false,
  },
  LEVEL: {
    label: 'Level-funded',
    userRoles: ['IM_CELTICS'],
    title: 'Select a product type from the level-funded catalog.',
    showFavoriteCard: false,
  },
  SPECIAL: {
    label: 'Special',
    userRoles: ['IM_CELTICS'],
    title: 'Select a product type from the special catalog.',
    showFavoriteCard: false,
  },
});

export const RATE_SEGMENT_TITLES: Record<RateSegment, string> = Object.freeze({
  GROUP: 'Shelf',
  CUSTOM: 'Custom',
  INDIVIDUAL: 'Individual',
  ASSOCIATION: 'Association',
  LEVEL: 'Level-funded',
  SPECIAL: 'Special',
});

/** For RFQ flow */
export const availableRateSegmentOptions = [
  {
    value: 'GROUP',
    label: RATE_SEGMENT_TITLES.GROUP,
  },
  {
    value: 'CUSTOM',
    label: RATE_SEGMENT_TITLES.CUSTOM,
  },
];

export function availableRateSegmentsOptions(availableRateSegments: RateSegment[]): OptionType[] {
  return availableRateSegments.map((rateSegment) => ({
    value: rateSegment,
    label: RATE_SEGMENT_TITLES[rateSegment],
  }));
}
